import { defineVueComponent } from '@/jsx-utils'

export const LayoutView = defineVueComponent((props: any, { slots }: any) => {
  return () => <div class="text-center tracking-normal">{slots.default?.()}</div>
})
